import { injectReducer } from '../../store/reducers';

export default store => (
  {
    path: 'feedback',
    childRoutes: [
      {
        path: 'hotel(/:id(/:action))',
        getComponent(nextState, cb) {
          const HotelFeedbackContainer = require('./containers/HotelFeedbackContainer').default; // eslint-disable-line global-require
          const reducer = require('./modules/feedback').default; // eslint-disable-line global-require
          injectReducer(store, { key: 'feedback', reducer });

          cb(null, HotelFeedbackContainer);
        },
      },
      {
        path: 'thanks',
        getComponent(nextState, cb) {
          const FeedbackThanks = require('./components/FeedbackThanks').default; // eslint-disable-line global-require
          const reducer = require('./modules/feedback').default; // eslint-disable-line global-require
          injectReducer(store, { key: 'feedback', reducer });

          cb(null, FeedbackThanks);
        },
      },
    ],
    /*  Async getComponent is only invoked when route matches   */
    getComponent(nextState, cb) {
      const Feedback = require('./containers/FeedbackContainer').default;
      const reducer = require('./modules/feedback').default;

      injectReducer(store, { key: 'feedback', reducer });
      /*  Return getComponent   */
      cb(null, Feedback);
    },
  }
);



// WEBPACK FOOTER //
// src/routes/feedback/index.js